var $41c4b2bb61dafbca$exports = {};
$41c4b2bb61dafbca$exports = {
  "Empty": "Vac\xEDo"
};
export { $41c4b2bb61dafbca$exports as default };